{
  "name": "root",
  "version": "1.15.0",
  "description": "Monorepo for @homer packages",
  "private": true,
  "homer": {
    "root": true
  },
  "license": "MIT",
  "workspaces": [
    "packages/**/*",
    "server/apfelkiste",
    "server/homer/configuration",
    "server/homer/http/abstract",
    "server/homer/http/middleware",
    "server/homer/http",
    "server/homer/i18n",
    "server/homer/logger",
    "server/homer/middleware",
    "server/homer/provider",
    "server/homer/renderer",
    "server/homer/shared",
    "cloudflare/**/*",
    "script",
    "playwright",
    "mock"
  ],
  "scripts": {
    "cleanup": "./script/cleanup.sh",
    "ncu": "./script/ncu.mjs",
    "test": "node ./script/test.mjs",
    "benchmark:frontend": "node ./script/benchmark/frontend.mjs",
    "benchmark:middleware": "node ./script/benchmark/middleware.mjs",
    "validate": "./script/runValidate.mjs",
    "release": "./script/release.mjs",
    "watcher:kill": "./script/watcher/kill.sh",
    "watcher": "./script/watcher/index.mjs",
    "mock": "nodemon --watch ./mock/definition --exec lightweight-mock-server --port=4000 --entrypoint=./mock/definition/index.js",
    "watcher:debug": "./script/watcher/index.mjs --debug true",
    "configure:worker": "script/configureWorker.mjs",
    "builder": "./script/builder/index.mjs",
    "setup": "npm install && husky && npm run update:browserslist && npm run builder",
    "setup:mac": "npm install && npm run mkcert:import && husky && npm run update:browserslist && npm run builder",
    "mkcert:import": "sudo security add-trusted-cert -d -p ssl -p basic -k /Library/Keychains/System.keychain dev/etc/caddy/ca.crt",
    "mkcert:generate": "mkcert create-cert --ca-key dev/etc/caddy/ca.key --ca-cert dev/etc/caddy/ca.crt --key dev/etc/caddy/server.key --cert dev/etc/caddy/server.crt --domains 'www.apfelkiste-dev.ch' --validity 825",
    "update:state": "npm run validate && npm run builder",
    "update:dependencies": "npm run ncu",
    "update:browserslist": "npx --no-install --yes clear-npx-cache@latest && npx --no-install --yes update-browserslist-db@latest && npm install --workspace=@homer/script --save-dev --save-exact baseline-browser-mapping@latest && node --input-type=module -e \"import { getBrowserMinifierTargets } from './script/shared/package/minifier-targets.mjs'; getBrowserMinifierTargets()\"",
    "warmer": "NODE_TLS_REJECT_UNAUTHORIZED='0' node --no-warnings ./script/warmer.mjs"
  },
  "rewrite": {
    "vue": "@homer.adapter/vue"
  },
  "disabled": [
    "@apfelkiste/zendesk",
    "@homer.auth/onetap"
  ],
  "devDependencies": {
    "@commitlint/cli": "21.2.2",
    "@commitlint/config-conventional": "21.2.2",
    "commitizen": "4.3.2",
    "crawler-user-agents": "1.60.0",
    "husky": "9.1.7",
    "lint-staged": "17.3.0",
    "miniflare": "5.20260804.1-alpha",
    "mkcert": "3.2.0",
    "npm-check-updates": "23.0.2",
    "prettier": "3.9.6",
    "smol-toml": "1.8.0"
  }
}
